// Blocage entre membres — un choix personnel, distinct de la suspension.
// A bloque B : ils ne voient plus leurs publications respectives et ne peuvent
// plus s'écrire. Le masquage est appliqué dans l'enveloppe du store, donc
// automatiquement dans tous les écrans.
import Store from "../store.js";
import { esc, avatar, toast, confirmer, modale, vide } from "../ui.js";

/** Demande confirmation puis bloque. */
export async function bloquerMembre(membre, apres) {
  const ok = await confirmer(
    `Bloquer ${membre.nom} ?`,
    "Vous ne verrez plus ses publications et il ne verra plus les vôtres. Vous ne pourrez plus vous écrire, et votre lien d'amitié sera retiré.",
    "Bloquer"
  );
  if (!ok) return false;
  try {
    await Store.blocages.bloquer(membre.uid);
    toast(`${membre.nom} est bloqué`);
    apres?.();
    return true;
  } catch (e) {
    toast(e.message || "Blocage impossible", "erreur");
    return false;
  }
}

export async function debloquerMembre(membre, apres) {
  await Store.blocages.debloquer(membre.uid);
  toast(`${membre.nom} est débloqué`);
  apres?.();
}

/** Liste des membres que J'AI bloqués, avec un bouton pour les débloquer. */
export function ouvrirListeBloques(ctx) {
  const { el } = modale({
    titre: "Membres bloqués",
    corps: `<div id="liste-bloques">Chargement…</div>`,
  });
  const zone = el.querySelector("#liste-bloques");

  const stop = Store.blocages.subscribeMiens(async (ids) => {
    if (!ids.length) {
      zone.innerHTML = vide("🕊️", "Personne de bloqué", "");
      return;
    }
    const membres = (await Promise.all(ids.map((id) => ctx.profil(id)))).filter(Boolean);
    zone.innerHTML = `<div class="grille-membres">${membres
      .map(
        (u) => `
      <div class="membre">
        <span class="membre__qui">${avatar(u, 44)}<span><strong>${esc(u.nom)}</strong></span></span>
        <button class="btn btn--gris btn--petit" data-debloquer="${esc(u.uid)}">Débloquer</button>
      </div>`
      )
      .join("")}</div>`;
  });

  zone.addEventListener("click", async (e) => {
    const b = e.target.closest("[data-debloquer]");
    if (!b) return;
    const u = await ctx.profil(b.dataset.debloquer);
    await debloquerMembre(u || { uid: b.dataset.debloquer, nom: "Ce membre" });
  });

  // la modale se ferme : on coupe l'abonnement
  el.addEventListener("click", (e) => {
    if (e.target === el || e.target.closest("[data-fermer]")) stop && stop();
  });
}
